var Handlebars = require("../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "for "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + " ";
},"3":function(container,depth0,helpers,partials,data) {
    return "in";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel-heading\">\n  <h3 class=\"panel-title\">\n    <a role=\"button\" data-toggle=\"collapse\" class=\"collapsed\" href=\"#collapse-additional-filters-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\">"
    + alias2(__default(require("../../helpers/t.js")).call(alias3,"Additional Filters",{"name":"t","hash":{},"data":data,"loc":{"start":{"line":3,"column":105},"end":{"line":3,"column":131}}}))
    + " "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"singleLayerModeUsed") : depth0),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":3,"column":132},"end":{"line":3,"column":190}}})) != null ? stack1 : "")
    + "<span class=\"caret\"></span></a>\n  </h3>\n</div>\n<div id=\"collapse-additional-filters-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "\" class=\"panel-body collapse "
    + ((stack1 = lookupProperty(helpers,"unless").call(alias3,(depth0 != null ? lookupProperty(depth0,"collapsed") : depth0),{"name":"unless","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":72},"end":{"line":6,"column":106}}})) != null ? stack1 : "")
    + "\"></div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// /src/views/filters/ExtraParametersListView.hbs
// module id = 2074
// module chunks = 0